<template>
    <v-alert type="error" icon="error" dense :value="!!error" class="mb-4"> 
        <div>
            {{ error }}
        </div> 
    </v-alert>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { useErrorStore } from "@/stores/errorStore";
import { storeToRefs } from "pinia";

@Component
export default class Logout extends Vue 
{
    // TODO: Change to composition api
    error = storeToRefs(useErrorStore()).errorMessage;
    // END TODO

    async created()
    {
        useErrorStore().setError(new Error(this.$t('LOGOUT_MESSAGE').toString()));
    }
}
</script>
